"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackFormController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const apiPath = endpoints_1.endpoints.feedbackForm;
const feedbackFormController = (service) => ({
    create: (item) => {
        return service.post(apiPath, item, service.addAccessTokenToHeaders);
    },
    readLatest: (appGuid) => {
        return service.get(`${apiPath}/${appGuid}`);
    },
    readAllForAdmin: () => {
        return service.get(`${apiPath}/Admin`, service.addAccessTokenToHeaders);
    },
    update: (item) => {
        return service.put(apiPath, item, service.addAccessTokenToHeaders);
    },
    del: (guid) => {
        const url = `${apiPath}/${guid}`;
        return service.delete(url, service.addAccessTokenToHeaders);
    }
});
exports.feedbackFormController = feedbackFormController;
